export class SnapshotStorage {
    'sizeBytes';
    'eonSnapshotCount';
    'nonEonSnapshotCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "eonSnapshotCount",
            "baseName": "eonSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nonEonSnapshotCount",
            "baseName": "nonEonSnapshotCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotStorage.attributeTypeMap;
    }
    constructor() {
    }
}
